import { render } from "./ReviewSearchForm.vue?vue&type=template&id=c54d1da4"
import script from "./ReviewSearchForm.vue?vue&type=script&lang=js"
export * from "./ReviewSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__